import { StoreType } from '@tock/shared/utils/connect';

export const getAuthState = (state: StoreType) => {
  return {
    jwtToken: state.app.jwtToken,
    activeAuth: state.app.activeAuth,
    csrfToken: state.app.csrfToken,
  };
};
